import newsletterListStore from '@modules/newsletter/newsletter-list-store';
import newsletterViewStore from '@modules/newsletter/newsletter-view-store';
import newsletterImporterStore from '@modules/newsletter/newsletter-importer-store';
import newsletterFormStore from '@modules/newsletter/newsletter-form-store';
import newsletterDestroyStore from '@modules/newsletter/newsletter-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: newsletterDestroyStore,
    form: newsletterFormStore,
    list: newsletterListStore,
    view: newsletterViewStore,
    importer: newsletterImporterStore,
  },
};
